import { Helmet } from 'react-helmet-async';

const SITE = 'https://www.nappr.io';

/** Page <title>, description, social tags and robots. Pass `noindex` for private pages. */
export function Seo({ title, description, image, canonical, noindex = false, type, keywords, children }) {
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      {type && <meta property="og:type" content={type} />}
      {canonical && <link rel="canonical" href={canonical.startsWith('http') ? canonical : `${SITE}${canonical}`} />}
      {canonical && <meta property="og:url" content={canonical.startsWith('http') ? canonical : `${SITE}${canonical}`} />}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {children}
    </Helmet>
  );
}
